




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Insertion {
    billingCode: {
        productCode: string,
    };
}

@Component({ components: { SimpleText } })
export default class ProductCode extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.billingCode.productCode",
        ];
    }
}
